import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Barcode from "react-barcode";
import {baseUrl, userLocation} from "../Univ.js";
function LabReportOp() {
    const {id} = useParams();
    const [labData, setLabData] = useState([]);
    const [labtestData, setLabTestData] = useState([]);
    const [labbillData, setLabBillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    /* =====================================================
       FETCH DATA
       ===================================================== */
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response1 = await axios.get(baseUrl + "lab-report-op/" + id + "/");
                const testData = response1.data || [];
                setLabTestData(testData);
                if (!testData.length) {
                    return;
                }
                const ltestid = testData[0]?.ltest_id;
                const appt_id = testData[0]?.appt_id;
                /* =================================================
                   LAB TEST DETAILS
                   ================================================= */
                if (ltestid) {
                    const response2 = await axios.get(baseUrl + "lab-test-view/" + ltestid + "/");
                    setLabBillData(Array.isArray(response2.data) ? response2.data : []);
                }
                /* =================================================
                   LAB PAYMENT / PATIENT DETAILS
                   ================================================= */
                if (appt_id) {
                    const response3 = await axios.get(baseUrl + "lab-pay/" + appt_id);
                    setLabData(Array.isArray(response3.data) ? response3.data : []);
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
        try {
            axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }, [id]);
    /* =====================================================
       PRINT
       ===================================================== */
    const handlePrint = () => {
        window.print();
    };
    /* =====================================================
       FIRST RECORDS
       ===================================================== */
    const firstLab = labData.length > 0 ? labData[0] : null;
    const firstTest = labtestData.length > 0 ? labtestData[0] : null;
    /* =====================================================
       RESULTS
       ===================================================== */
    const results = firstTest?.results ? String(firstTest.results)
        .split(",")
        .map((item) => item.trim()) : [];
    const abnormal = firstTest?.results ? String(firstTest.abnormal_status)
        .split(",")
        .map((item) => item.trim()) : [];
    /* =====================================================
       CATEGORY
       ===================================================== */
    const category = labbillData.length > 0 ? labbillData[0]?.cat?.category || "" : "";
    /* =====================================================
       SUB CATEGORY
       ===================================================== */
    const subCategory = labbillData.length > 0 ? labbillData[0]?.subcat?.subcat || "" : "";
    return (<section className="lab-report-page">

        {/* =================================================
                PRINT AREA
            ================================================= */}

        <div
            id="invoice-print"
            className="lab-report-print"
        >


            {/* =================================================
                    PATIENT HEADER
                ================================================= */}
            <div
                style={{
                    width: "100%", margin: 0, padding: 0, overflow: "hidden", lineHeight: 0
                }}
            >
                {hospData.map((hospital) => (<img
                    key={hospital.id}
                    src={hospital.logo}
                    alt="Hospital Header"
                    style={{
                        width: "100%",
                        height: "110px",
                        display: "block",
                        margin: 0,
                        padding: 0,
                        border: "none",
                        objectFit: "fill"
                    }}
                />))}
            </div>
            {firstLab && (<div className="lab-patient-box">


                {/* =========================================
                            LEFT COLUMN
                        ========================================= */}

                <div className="lab-patient-column">


                    {/* PID / BARCODE */}

                    <div className="lab-info-row lab-pid-row">

                        <div className="lab-label">
                            PID :
                        </div>

                        <div className="lab-value lab-barcode">

                            {firstLab?.pat?.pat_id && (<Barcode
                                width={1.5}
                                height={42}
                                fontSize={10}
                                margin={0}
                                value={String(firstLab.pat.pat_id)}
                            />)}

                        </div>

                    </div>


                    {/* NAME */}

                    <div className="lab-info-row">

                        <div className="lab-label">
                            Name :
                        </div>

                        <div className="lab-value">

                            {firstLab?.pat?.patient || "-"}

                        </div>

                    </div>


                    {/* AGE / GENDER */}

                    <div className="lab-info-row">

                        <div className="lab-label">
                            Age / Gender :
                        </div>

                        <div className="lab-value">

                            {firstLab?.pat?.age || "-"}
                            {" / "}
                            {firstLab?.pat?.gender || "-"}

                        </div>

                    </div>

                </div>


                {/* =========================================
                            RIGHT COLUMN
                        ========================================= */}

                <div className="lab-patient-column">


                    {/* SAMPLE DATE */}

                    <div className="lab-info-row">

                        <div className="lab-label">
                            Sample Date :
                        </div>

                        <div className="lab-value">

                            {firstLab?.add_date || "-"}

                        </div>

                    </div>


                    {/* REPORT DATE */}

                    <div className="lab-info-row">

                        <div className="lab-label">
                            Report Date :
                        </div>

                        <div className="lab-value">

                            {firstTest?.sample_date || "-"}

                        </div>

                    </div>


                    {/* MOBILE */}

                    <div className="lab-info-row">

                        <div className="lab-label">
                            Mobile :
                        </div>

                        <div className="lab-value">

                            {firstLab?.pat?.mobile || "-"}

                        </div>

                    </div>


                    {/* CONSULTANT */}

                    <div className="lab-info-row">

                        <div className="lab-label">
                            Consultant :
                        </div>

                        <div className="lab-value">

                            {firstLab?.cons?.consultant ? `Dr. ${firstLab.cons.consultant}` : "-"}

                        </div>

                    </div>

                </div>

            </div>)}


            {/* =================================================
                    RESULT TABLE
                ================================================= */}

            <div className="lab-result-wrapper">

                <table className="lab-result-table">


                    {/* =========================================
                            COLUMN WIDTHS
                        ========================================= */}

                    <colgroup>

                        <col className="col-test"/>

                        <col className="col-value"/>

                        <col className="col-unit"/>

                        <col className="col-range"/>

                    </colgroup>


                    {/* =========================================
                            TABLE HEADER
                        ========================================= */}

                    <thead>

                    <tr>

                        <th>
                            Test Description
                        </th>

                        <th>
                            Values
                        </th>

                        <th>
                            Unit
                        </th>

                        <th>

                            Ref. Range
                        </th>

                    </tr>

                    </thead>


                    {/* =========================================
                            TABLE BODY
                        ========================================= */}

                    <tbody>


                    {/* =====================================
                                CATEGORY
                            ===================================== */}

                    {category && (<tr className="lab-category-row">

                        <td colSpan="4">
                            {category}
                        </td>

                    </tr>)}


                    {/* =====================================
                                SUB CATEGORY
                            ===================================== */}

                    {subCategory && (<tr className="lab-subcategory-row">

                        <td colSpan="4">
                            {subCategory}
                        </td>

                    </tr>)}


                    {/* =====================================
                                TEST RESULTS
                            ===================================== */}

                    {labbillData.map((lab, billIndex) => {
                        const resultValue = results[billIndex] !== undefined ? results[billIndex] : "-";
                        // abnormal_status belongs to the original API record,
                        // not to each individual test-definition row.
                        const isAbnormal = abnormal[billIndex] === "1";
                        return (<tr key={billIndex}>
                                <td className="test-description">
                                    <div className="test-name">
                                        {lab?.test || "-"}
                                    </div>

                                    {lab?.method && (<div className="test-method">
                                            {lab.method}
                                        </div>)}
                                </td>

                                <td
                                    className="test-value"
                                    style={{

                                        textDecoration: isAbnormal ? "underline" : "none",
                                        textDecorationColor: "red",
                                        textDecorationThickness: "3px",
                                        textUnderlineOffset: "3px",
                                        fontWeight: 700,
                                    }}
                                >
                                    {resultValue}
                                </td>

                                <td className="test-unit">
                                    {lab?.units || "-"}
                                </td>

                                <td className="test-range">
                                    {lab?.ranges || "-"}
                                </td>
                            </tr>);
                    })}
                    {/* =====================================
                                NO RESULTS
                            ===================================== */}

                    {labbillData.length === 0 && (<tr>

                        <td
                            colSpan="4"
                            className="no-results"
                        >
                            No laboratory results available.
                        </td>

                    </tr>)}

                    </tbody>

                </table>

            </div>


            {/* =================================================
                    FOOTER
                ================================================= */}

            <div className="lab-report-footer">


                {/* END OF REPORT */}

                <div className="report-end">

                    *** End of Report ***

                </div>


                {/* TECHNICIAN */}

                <div className="technician-signature">

                    Lab Technician

                </div>


                {/* DISCLAIMER */}

                <div className="lab-disclaimer">

                    <strong>Disclaimer:</strong>{" "}
                    All investigations have their limitations which
                    are imposed by the limits of sensitivity and
                    specificity of individual assay procedures as
                    well as the specimen received by the laboratory.
                    Isolated laboratory investigations never confirm
                    the final diagnosis of the disease. They only help
                    in arriving at a diagnosis in conjunction with
                    clinical presentation and other related
                    investigations. Report may vary depending on
                    technology. Values of two technologies are not
                    comparable.

                </div>

            </div>

        </div>


        {/* =====================================================
                PRINT BUTTON
            ===================================================== */}

        <div className="lab-print-button-container">

            <button
                type="button"
                className="lab-print-button"
                onClick={handlePrint}
            >
                Print
            </button>

        </div>

    </section>);
}
export default LabReportOp;